function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export function Clock(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1)"
  }, React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10
  }), React.createElement("path", {
    d: "M10 4v6l4 2"
  })));
}